// --------------------------------------------------------------------------
// Auto Countdown - countdown that starts running on page load with
//                  a predefined timestamp, e.g. date-timestamp="1499763458"
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var ref = { $root: options.context, $document: jQuery(document) };
    var state = {
        timeDiff: 0
    };

    function render() {
        // this will be displayed if the time difference is none or negative
        var display = '00:00';

        if (state.timeDiff > 0) {
            // convert seconds to hh:mm:ss format and delete leading 00: if time difference is under an hour
            display = new Date(state.timeDiff * 1000).toISOString().substr(11, 8).replace(/^00:/, '');
        }

        ref.$timeLeft.html(display);
    }

    // base the calculation on the same UTC time-zone base
    function dateDiff(a, b) {
        var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds());
        var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate(), b.getHours(), b.getMinutes(), b.getSeconds());

        return Math.floor((utc2 - utc1) / 1000);
    }

    function onInterval() {
        state.timeDiff = dateDiff(new Date(), ref.timestamp);

        if (state.timeDiff <= 0) {
            clearInterval(ref.interval);

            // reload withou sending POST data again
            window.location.href = window.location.href;
        }

        render();
    }

    function init() {
        // Cache DOM elements
        ref.$timeLeft = ref.$root.find('[data-name="time-left"]');
        ref.timestamp = new Date(ref.$root.data('timestamp') * 1000);

        // Set state
        function initialState() {
            // compute number of seconds
            return {
                timeDiff: dateDiff(new Date(), ref.timestamp)
            };
        }

        state = initialState();

        // run the timer only if there's a time difference, otherwise the reload would happen
        if (state.timeDiff > 0) {
            // calculate and display the time difference between now and the timestamp every second
            ref.interval = setInterval(onInterval, 1000);
        }

        // Render component
        render();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/auto-countdown.js
// module id = 491
// module chunks = 0